module.exports = (loadingPage) => {
    return {
        loadingPage: loadingPage,

        showLoading: function() {
            if (Odigeo.SessionScope.flow === 'desktop') {
                this.loadingPage.showLoading(['waiting_confirmation_automatic_redirection', 'waiting_bottom',
                    'waiting_confirmation', 'waiting_bottom_gradient']);
            } else {
                this.loadingPage.showLoading(['waiting_confirmation_automatic_redirection']);
            }
        },

        closeLoading: function() {
        },

        showError: function() {
        },
    };
};
